import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Keep the existing OAuth callback URL. Onboarding checks `/apps/v1/me` with
 * the session cookie before showing real organizations, projects or keys.
 * Never send a new sign-in into the fixture dashboard. Its transport uses
 * VITE_AUX0_API_ORIGIN, deliberately independent of the VITE_CORE_URL switch.
 */
export const Route = createFileRoute("/signed-in")({
  beforeLoad: () => {
    throw redirect({ to: "/onboarding", replace: true });
  },
});
